module.exports = __webpack_public_path__ + "static/media/12flujodecaja.5832b9c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/12flujodecaja.mp4
// module id = 720
// module chunks = 1